class onScrollAnimations {
    constructor() {
        let mm = gsap.matchMedia();

        mm.add('(min-width: 990px)', () => {
            this.richTextAppear();
            this.fullWidthImageAppear();
            //this.h1BannerTranslate();
        });

        // this.goldTemplate();
        this.arrayAppear();
        this.numbersCounter();
        this.footerTitleScrollTrigger();
        this.h2ScrollTrigger();
        this.programsCards();
        this.lotsAppear();
        // this.newsCards();
        //this.italScrollTrigger();
        //this.h3ScrollTrigger();
        //this.sectionsAppear();
    }

    // goldTemplate() {
    // 	const rehab = document.querySelector('.term-programme-en-rehabilitation');
    //
    // 	if (!rehab) {
    // 		return;
    // 	}
    //
    // 	rehab.classList.add('gold-template');
    // }

    h2ScrollTrigger() {
        const title = document.querySelectorAll('.title-level-2');

        title.forEach(title => {
            const splitTitle = new SplitText(title, {
                type: "chars, lines",
                charsClass: "char",
                linesClass: "line",
            });

            splitTitle.lines.forEach(line => {
                const chars = line.querySelectorAll('.char');

                gsap.set(chars[0].parentNode, {perspective: 1000});
                gsap.set(chars, {
                    'will-change': 'opacity, transform',
                    opacity: 0,
                    rotationX: -90,
                    yPercent: 50
                });
                gsap.to(chars, {
                    ease: 'power1.inOut',
                    opacity: 1,
                    rotationX: 0,
                    yPercent: 0,
                    stagger: {
                        each: 0.03,
                        from: 0
                    },
                    scrollTrigger: {
                        // markers: true,
                        trigger: line,
                        start: 'top bottom',
                        end: 'top 80%',
                        scrub: 0.9,
                    },
                });
            });

            // gsap.to(title, {
            // 	'--wght': 200,
            // 	'--wdth': 100,
            // 	ease: 'none',
            // 	scrollTrigger: {
            // 		// markers: true,
            // 		trigger: title,
            // 		start: 'center bottom+=40%',
            // 		end: 'top 50%',
            // 		scrub: true,
            // 	}
            // });
        });
    }

    italScrollTrigger() {

        const ctaTitles = document.querySelectorAll('.cta-title');

        ctaTitles.forEach(ctaTitle => {
            const test = gsap.to(ctaTitle, {
                '--ital': 10,
                '--wght': 900,
                ease: 'none',
                scrollTrigger: {
                    trigger: ctaTitle,
                    start: 'top 90%',
                    end: 'top 10%',
                    scrub: true,
                }
            });
        });
    }

    h3ScrollTrigger() {
        const h3Titles = document.querySelectorAll('.title-level-3');

        h3Titles.forEach(h3Title => {
            gsap.to(h3Title, {
                '--slnt': 0,
                ease: 'none',
                scrollTrigger: {
                    // markers: true,
                    trigger: h3Title,
                    start: 'top 90%',
                    end: 'top 50%',
                    scrub: true,
                }
            });
        });
    }

    footerTitleScrollTrigger() {
        const footerTitles = document.querySelectorAll('.title-footer');

        footerTitles.forEach(footerTitle => {
            gsap.to(footerTitle, {
                // '--wght': 200,
                // '--wdth': 100,
                ease: 'none',
                scrollTrigger: {
                    // markers: true,
                    trigger: footerTitle,
                    start: 'top 90%',
                    end: 'top 10%',
                    scrub: true,
                }
            });
        });
    }

    numbersCounter() {
        const keyNumbers = document.querySelectorAll('.block-key-numbers');

        keyNumbers.forEach(keyNumber => {
            gsap.to(keyNumber, {
                scrollTrigger: {
                    // markers: true,
                    trigger: keyNumber,
                    start: 'top bottom',
                    scrub: true,
                    once: true,
                    onEnter: () => {
                        const numbers = document.querySelectorAll('.key-number');
                        let interval = 5000;

                        numbers.forEach(number => {
                            let startValue = 0;
                            let endValue = parseInt(number.getAttribute('data-number'));
                            let duration = Math.floor(interval / endValue);
                            let counter = setInterval(() => {
                                startValue++;
                                number.textContent = startValue;
                                if (startValue === endValue) {
                                    clearInterval(counter);
                                }
                            }, duration);
                        });
                    }
                }
            });
        });
    }

    fullWidthImageAppear() {
        const fullWidthImages = document.querySelectorAll('.block-fullwidth-image .mask');

        fullWidthImages.forEach(image => {
            gsap.set(image, {
                width: `50%`,
            });
            gsap.to(image, {
                width: `100%`,
                scrollTrigger: {
                    // markers: true,
                    trigger: image,
                    start: 'top bottom',
                    end: 'top 30%',
                    scrub: true,
                }
            });
        });
    }

    h1BannerTranslate() {
        const h1Banner = document.querySelector('.banner h1');
        const programName = document.querySelector('.program-title span');

        gsap.to(h1Banner, {
            x: -100,
            '--wdth': 200,
            opacity: 0,
            ease: 'none',
            scrollTrigger: {
                trigger: h1Banner,
                start: 'top 10%',
                end: 'top top',
                scrub: true,
            }
        });

        gsap.to(programName, {
            x: -100,
            '--wdth': 200,
            //opacity: 0,
            ease: 'none',
            scrollTrigger: {
                trigger: programName,
                start: 'top 10%',
                scrub: true,
            }
        });
    }

    richTextAppear() {
        const richTexts = document.querySelectorAll('.section .rich-text:not(.not-appear)');

        richTexts.forEach(richText => {
            gsap.set(richText, {
                y: 100,
                opacity: 0,
            });

            gsap.to(richText, {
                y: 0,
                opacity: 1,
                scrollTrigger: {
                    // markers: true,
                    trigger: richText,
                    start: 'top 80%',
                    end: 'top 50%',
                    scrub: true,
                }
            });
        });
    }

    sectionsAppear() {
        const sections = document.querySelectorAll('section');

        sections.forEach(section => {
            gsap.set(section, {
                y: 100,
                opacity: 0,
            });

            gsap.to(section, {
                y: 0,
                opacity: 1,
                scrollTrigger: {
                    // markers: true,
                    trigger: section,
                    start: 'top 90%',
                    end: 'top 20%',
                    scrub: true,
                }
            });
        });
    }

    programsCards() {
        const programsCards = document.querySelectorAll('.post-type-archive-programs .card');

        programsCards.forEach(programCard => {
            gsap.set(programCard, {
                y: 100,
                opacity: 0,
            });

            gsap.to(programCard, {
                y: 0,
                opacity: 1,
                scrollTrigger: {
                    // markers: true,
                    trigger: programCard,
                    start: 'top 80%',
                    end: 'top 50%',
                    scrub: true,
                }
            });
        });
    }

    newsCards() {
        const newsCards = document.querySelectorAll('.post-type-archive-news .news-card');

        newsCards.forEach(newsCard => {
            gsap.set(newsCard, {
                y: 100,
                opacity: 0,
            });

            gsap.to(newsCard, {
                y: 0,
                opacity: 1,
                scrollTrigger: {
                    // markers: true,
                    trigger: newsCard,
                    start: 'top 80%',
                    end: 'top 50%',
                    scrub: true,
                }
            });
        });
    }

    lotsAppear() {
        // const lotsSection = document.querySelector('.lots');
        const lots = document.querySelectorAll('.lots .lots-infos');

        gsap.set(lots, {
            y: 100,
            opacity: 0,

        });

        lots.forEach(lot => {
            gsap.to(lot, {
                y: 0,
                opacity: 1,
                scrollTrigger: {
                    // markers: true,
                    trigger: lot,
                    start: 'top 80%',
                    end: 'top 50%',
                    scrub: true,
                    once: true,
                }
            });
        });
    }

    arrayAppear() {
        const array = document.querySelectorAll('.table-container');

        array.forEach(array => {
            const tr = array.querySelectorAll('tbody tr');

            tr.forEach(tr => {
                gsap.set(tr, {
                    // y: 100,
                    autoAlpha: 0,
                });

                gsap.to(tr, {
                    // y: 0,
                    autoAlpha: 1,
                    duration: 1,
                    stagger: 0.2,
                    scrollTrigger: {
                        // markers: true,
                        trigger: tr,
                        start: 'top 80%',
                        end: 'top 60%',
                        scrub: true,
                        once: true,
                    }
                });
            });
        });
    }
}
